import React from "react";
import { Unstable_Grid2 as Grid, Typography } from "@mui/material";
import styled from "@emotion/styled";
import ReactMarkdown from "react-markdown";
import phase1Image from "../assets/leasing/phase-1.png";
import phase2Image1 from "../assets/leasing/phase-2-option-1.jpg";
import phase2Image2 from "../assets/leasing/phase-2-option-2.jpg";

export default function Leasing({
  highlights,
  buildingSpecifications,
  siteMapData,
  cmsEndpoint,
  buildingData,
  ...props
}) {
  // React.useEffect(() => {
  //   siteMapData.Image[0].url = cmsEndpoint + siteMapData.Image[0].url;
  // }, []);

  console.log("buildingSpecifications: ", buildingSpecifications);
  console.log("buildingData: ", buildingData);

  const addBuildingAreaSpec = array => {
    if (!array || array.length === 0) {
      return;
    }
    for (const building of array) {
      const alreadyHas = building.Specifications.some(spec => spec.Label === "Building Area");

      if (!alreadyHas) {
        building.Specifications.push({
          Label: "Building Area",
          detail: building.Area,
        });
      }
    }
  };

  const phase1 = buildingData
    ?.filter(building => building.Phase === Number(1))
    ?.sort((a, b) => {
      return Number(a.Address.split(" ")[1]) - Number(b.Address.split(" ")[1]);
    });

  const phase2Option1 = buildingData
    ?.filter(building => building.Phase === Number(2))
    ?.sort((a, b) => {
      return Number(a.Address.split(" ")[1]) - Number(b.Address.split(" ")[1]);
    });

  const phase2Option2 = buildingData
    ?.filter(building => building.Phase === Number(3))
    ?.sort((a, b) => {
      return Number(a.Address.split(" ")[1]) - Number(b.Address.split(" ")[1]);
    });

  const mappedBuildings = [[...phase1], [...phase2Option1], [...phase2Option2]];

  mappedBuildings.forEach(phase => {
    addBuildingAreaSpec(phase);
  });

  console.log("mappedBuildings: ", mappedBuildings);

  const filteredBuildingSpecs = buildingSpecifications;

  return (
    <>
      <Wrapper
        container
        justifyContent={"space-evenly"}
        alignItems={"center"}
        backgroundColor="#F5F6F6"
        pt={{ xs: 2, md: 6 }}
        pb={{ xs: 2, md: 6 }}
        mb={{ xs: 4, md: 8 }}
        pl={{ md: 8 }}
        // pr={{ md: 8 }}
        flexDirection={{ xs: "column-reverse", md: "row" }}
      >
        <Grid
          item
          xs={12}
          md={4}
          pl={{ xs: 4, sm: 10, md: 0 }}
          pr={{ xs: 4, sm: 10, md: 0 }}
          pt={{ xs: 4, sm: 0 }}
        >
          <Typography variant={"h1"} color="primary.main" align="left">
            {highlights.title}
          </Typography>

          <ReactMarkdown>{highlights.notes}</ReactMarkdown>
        </Grid>
        <Grid item xs={12} md={8} pl={{ xs: 4, sm: 10 }} pr={{ xs: 4, sm: 10 }}>
          {/* <img
            src={`${cmsEndpoint}${siteMapData?.Image[0].url}`}
            alt={siteMapData?.alternativeText}
            style={{ width: "100%", height: "auto" }}
          /> */}
        </Grid>
      </Wrapper>

      <Wrapper2>
        <div className="buildings-wrapper">
          {mappedBuildings &&
            mappedBuildings.length > 0 &&
            mappedBuildings.map((phase, index) => (
              <div>
                <Typography
                  variant="h1"
                  color="primary.main"
                  align="left"
                  pl={{ xs: 4, sm: 10 }}
                  pr={{ xs: 4, sm: 10 }}
                >
                  {index === 0 && "Phase 1 - Leased To Princess Auto, Opening Q3 - 2026"}
                  {index === 1 && "Phase 2 - Option 1 - Coming 2027"}
                  {index === 2 && "Phase 2 - Option 2 - Coming 2027"}
                </Typography>
                {phase &&
                  phase.length > 0 &&
                  phase.map((building, index) => {
                    return (
                      <Grid
                        key={building}
                        container
                        spacing={"1px"}
                        pl={{ xs: 4, sm: 10 }}
                        pr={{ xs: 4, sm: 10 }}
                      >
                        <Grid
                          component={Typography}
                          variant="h2"
                          color="primary.main"
                          align="left"
                          xs={12}
                          mb={2}
                          mt={2}
                        >
                          {building.Address}
                        </Grid>

                        {building.Specifications.map((spec, index) => {
                          return (
                            <Grid
                              key={spec.Label + spec.detail + index}
                              // xs={12}
                              // sm={2}
                              // md={2}
                              // mb={{ xs: 1, md: 4 }}
                              xs={12}
                              sm={Math.floor(12 / building.Specifications.length)} // divide evenly
                            >
                              <Grid container flexDirection={"column"}>
                                <Grid
                                  p={{ xs: 0.5, sm: 1, md: 2 }}
                                  backgroundColor="grey.backgroundGrey"
                                  color="white"
                                  fontWeight="bold"
                                  whiteSpace="nowrap"
                                  fontSize={{ sm: "x-small", md: "smaller", lg: "initial" }}
                                  width={"100%"}
                                >
                                  {spec.Label}
                                </Grid>
                                <Grid
                                  width={"100%"}
                                  p={{ xs: 0.5, md: 2 }}
                                  fontWeight={spec.Label === "Building Area" ? "bold" : null}
                                  color={spec.Label === "Building Area" ? "primary.main" : null}
                                >
                                  {spec.Label === "Building Area"
                                    ? `${spec.detail.toLocaleString()} SF`
                                    : spec.detail}
                                </Grid>
                              </Grid>
                            </Grid>
                          );
                        })}
                      </Grid>
                    );
                  })}
                <img
                  src={index === 0 ? phase1Image : index === 1 ? phase2Image1 : phase2Image2}
                  alt={
                    index === 0
                      ? "Phase 1 - Leased To Princess Auto, Opening Q3 - 2026"
                      : index === 1
                      ? "Phase 2 - Option 1"
                      : "Phase 2 - Option 2"
                  }
                  style={{ width: "100%", height: "auto", maxWidth: "100%", margin: "2rem 0rem" }}
                />
              </div>
            ))}
        </div>
      </Wrapper2>

      {/* {filteredBuildingSpecs.building1.name && (
        <Typography
          variant="h1"
          color="primary.main"
          align="left"
          pl={{ xs: 4, sm: 10 }}
          pr={{ xs: 4, sm: 10 }}
        >
          Phase 1 - Fully Leased
        </Typography>
      )}
      {Object.keys(filteredBuildingSpecs).map((building, index) => {
        return (
          <Grid
            key={building}
            container
            spacing={"1px"}
            pl={{ xs: 4, sm: 10 }}
            pr={{ xs: 4, sm: 10 }}
          >
            {filteredBuildingSpecs[building].phase === 1 && (
              <Grid
                component={Typography}
                variant="h2"
                color="primary.main"
                align="left"
                xs={12}
                mb={2}
                mt={2}
              >
                {filteredBuildingSpecs[building].name}
              </Grid>
            )}
            {filteredBuildingSpecs[building].phase === 1 &&
              filteredBuildingSpecs[building].data.map((spec, index) => {
                return (
                  <Grid key={spec[0] + spec[1] + index} xs={12} sm={2} md={2} mb={{ xs: 1, md: 4 }}>
                    <Grid container flexDirection={"column"}>
                      <Grid
                        p={{ xs: 0.5, sm: 1, md: 2 }}
                        backgroundColor="grey.backgroundGrey"
                        color="white"
                        fontWeight="bold"
                        whiteSpace="nowrap"
                        fontSize={{ sm: "x-small", md: "smaller", lg: "initial" }}
                        width={"100%"}
                      >
                        {spec[0]}
                      </Grid>
                      <Grid
                        width={"100%"}
                        p={{ xs: 0.5, md: 2 }}
                        fontWeight={spec[0] === "Building Area" ? "bold" : null}
                        color={spec[0] === "Building Area" ? "primary.main" : null}
                      >
                        {spec[0] === "Building Area" ? spec[1].toLocaleString() : spec[1]}
                        {spec[0] === "Building Area" ? " SF" : null}
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
          </Grid>
        );
      })}
      {filteredBuildingSpecs.building1.name && (
        <Typography
          variant="h1"
          color="primary.main"
          align="left"
          pl={{ xs: 4, sm: 10 }}
          pr={{ xs: 4, sm: 10 }}
        >
          Phase 2 - Option 1
        </Typography>
      )}
      {Object.keys(filteredBuildingSpecs).map((building, index) => {
        return (
          <Grid
            key={building}
            container
            spacing={"1px"}
            pl={{ xs: 4, sm: 10 }}
            pr={{ xs: 4, sm: 10 }}
          >
            {filteredBuildingSpecs[building].phase === 2 && (
              <Grid
                component={Typography}
                variant="h2"
                color="primary.main"
                align="left"
                xs={12}
                mb={2}
                mt={2}
              >
                {filteredBuildingSpecs[building].name}
              </Grid>
            )}
            {filteredBuildingSpecs[building].phase === 2 &&
              filteredBuildingSpecs[building].data.map((spec, index) => {
                return (
                  <Grid key={spec[0] + spec[1] + index} xs={12} sm={2} md={2} mb={{ xs: 1, md: 4 }}>
                    <Grid container flexDirection={"column"}>
                      <Grid
                        p={{ xs: 0.5, sm: 1, md: 2 }}
                        backgroundColor="grey.backgroundGrey"
                        color="white"
                        fontWeight="bold"
                        whiteSpace="nowrap"
                        fontSize={{ sm: "x-small", md: "smaller", lg: "initial" }}
                        width={"100%"}
                      >
                        {spec[0]}
                      </Grid>
                      <Grid
                        width={"100%"}
                        p={{ xs: 0.5, md: 2 }}
                        fontWeight={spec[0] === "Building Area" ? "bold" : null}
                        color={spec[0] === "Building Area" ? "primary.main" : null}
                      >
                        {spec[0] === "Building Area" ? spec[1].toLocaleString() : spec[1]}
                        {spec[0] === "Building Area" ? " SF" : null}
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
          </Grid>
        );
      })} */}
    </>
  );
}
const Wrapper = styled(Grid)`
  ul {
    text-align: left;
    line-height: 2rem;
    li::marker {
      color: red; /* Change the color */
      font-weight: bold; /* If you want it to be bold */
      font-size: 1.5rem;
      position: absolute;
    }
  }
`;

const Wrapper2 = styled(Grid)`
    .buildings-wrapper {
      display: flex;
      flex-direction: column;
      gap: 4rem;
      margin-bottom: 4rem;

      h1 {
        margin-bottom: 2rem;
      }
    }
  }
  `;
